"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map2 = _interopRequireDefault(require("lodash/map"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * @param {Array} data [
 *      {
 *          pawn: {
 *              pawnId: 1
 *          }
 *          ...
 *      },
 *      {
 *          pawn: {
 *              pawnId: 2
 *          }
 *          ...
 *      }
 * ]
 * @return [1, 2]
 */
var _default = exports["default"] = function _default(data) {
  return (0, _map2["default"])(data, 'pawn.pawnId');
};